module.exports = __webpack_public_path__ + "img/service_img_1.587430b3.png";